import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';

const styles = () => ({
  root: {
    color: Theme.colors.primary,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
});

const TextButton = props => (
  <Button {...props} />
);

export default withStyles(styles)(TextButton);
